module.exports = __webpack_public_path__ + "static/media/eisai-logo.bfcd5ac5.png";